<template>
  <div
    class="px-2 py-1 text-[#FEFEFE] w-max text-base font-medium border-none"
    :class="[
      checkRounded ? 'rounded-b-3xl pt-2.5 pb-1.5' : 'rounded-b-lg',
      tagClass,
      borderTopClass,
    ]"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import { computed, withDefaults } from "vue";
import {
  getTagHeaderBorderTopClass,
  tagHeaderClass,
} from "features/ranking/ranking.utils";
import { EInterviewRank } from "~/features/question";

interface Props {
  rank?: EInterviewRank;
  checkRounded?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  rank: EInterviewRank.EXPERT,
  checkRounded: false,
});

const tagClass = computed(() => {
  return tagHeaderClass(props.rank);
});
const borderTopClass = computed(() => {
  return getTagHeaderBorderTopClass(props.rank);
});
</script>
